module.exports = __webpack_public_path__ + "img/phone-bg.0e2d018a.png";